import moment from 'moment';
import { DateType } from 'api/models';

export const convertDateToMoment = (date: DateType) => {
  if (date) {
    return moment(new Date(date));
  }

  return undefined;
};
